import React, { useEffect } from "react";
import './App.css';
import Home from './Home';
import Login from './Login';
import Careers from './Careers';
import { BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Header from "./Header";

import ShowMyTable from "./ShowMyTable";
import Bmt2 from "./Bmt2";
import Abc from "./Abc";
import Product from "./Product";
import BookMyTable from "./BookMyTable";
import CheckoutProduct from "./CheckoutProduct";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import Payment from "./Payment";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Orders from "./Orders"
import ThankYou from "./ThankYou";
import Xyz from "./Xyz";
import Abhi from "./About Us/Abhi";

const promise = loadStripe
('pk_live_51Im0QeSGfQCQZHG2WHCeQOI8l9NNIVav71gsYhlNBOPnMXgcLd4JOARDyqzSfcrPvuw3ehQYzAsZi5eq9YXsZjBf00Z5OgS6Ct');

function App() {
  const [{}, dispatch] = useStateValue();

  useEffect(() => {
    // will only run once when the app component loads....

    auth.onAuthStateChanged(authUser => {
      console.log('THE USER IS >>> ', authUser);

      if (authUser) {
        // the user just logged in / the user was logged in
        dispatch({
          type: 'SET_USER',
          user: authUser
        })
      }
      else {
        // the user is logged out
        dispatch({
          type: 'SET_USER',
          user: null
        })
      }
    })
  }, [])

  return (
    // BEM
    <Router>
      <div className="app">
      
        <Switch>

          <Route path='/abhi'>
            <Abhi />
          </Route>
          <Route path='/xyz'>
            <Header />
            <Bmt2 />
            <Xyz />
          </Route>
          <Route path='/thankyou'>
            <ThankYou />
          </Route>
          <Route path='/orders'>
            <Header />
            <Orders />
          </Route>
          <Route path="/payment">
            <Header />
            <Elements stripe={promise}>
              <Payment />
            </Elements>
            
          </Route>

          <Route path="/abc">
            <Header />
            <Abc />
            
          </Route>

          <Route path="/careers">
            <Careers />
          </Route>

          <Route path="/showmytable">
            <Header /> 
            <ShowMyTable />
          </Route>

          <Route path="/bookmytable">
            
            <Header />
            <BookMyTable />
            
          </Route>

          <Route path="/login">
            <Login />
          </Route>

          <Route path="/">
            <Home />
          </Route>
        </Switch>
            
      </div>
    </Router>
  );
}

export default App;
